import firebase from "firebase/app";
import "firebase/firestore";
console.log("dev_mode", process.env.VUE_APP_FIREBASE_PROJECT_ID.includes('dev'))

const config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY, //
  authDomain: process.env.VUE_APP_FIREBASE_PROJECT_ID + ".firebaseapp.com",
  databaseURL:
    "https://" + process.env.VUE_APP_FIREBASE_PROJECT_ID + ".firebaseapp.com",
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_PROJECT_ID + ".appspot.com",
  appId: process.env.VUE_APP_FIREBASE_ID,
};

const FirebaseApp = firebase.initializeApp(config);
const firestore = firebase.firestore();

FirebaseApp.db = firestore;
FirebaseApp.db.enablePersistence({ synchronizeTabs: true })

// firebase use firebase-project-iWanna

// firebase projects:list
// npm run build
// firebase deploy

export default FirebaseApp;
